import React from 'react';
import { Button } from './button';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const DetailsPanel = ({
    title,
    subtitle,
    onClose,
    headerRight,
    statusBar,
    children,
    className = '',
    hideCloseButton = false,
    headerClassName = '',
    contentClassName = '',
    titleClassName = '',
    subtitleClassName = '',
}) => {
    const mergedTitleClassName =
        titleClassName || 'text-sm font-semibold text-texts-secondary leading-tight truncate';
    const mergedSubtitleClassName =
        subtitleClassName || 'mt-0.5 text-xs text-texts-secondary300 leading-tight truncate';

    return (
        <div
            className={`w-full h-full bg-backgrounds-white flex flex-col border-l border-backgrounds-border ${className}`}
        >
            <div
                className={`flex items-center justify-between px-4 py-2 h-12 overflow-hidden border-b border-backgrounds-border bg-backgrounds-white ${headerClassName}`}
            >
                <div className='min-w-0'>
                    <div className={mergedTitleClassName}>
                        {title}
                    </div>
                    {subtitle ? (
                        <div className={mergedSubtitleClassName}>
                            {subtitle}
                        </div>
                    ) : null}
                </div>

                <div className='flex items-center gap-2'>
                    {headerRight}
                    {!hideCloseButton && (
                        <Button
                            className='w-6 h-6 rounded-full !p-0 flex items-center justify-center'
                            type='danger'
                            hoverText='Close'
                            icon={faTimes}
                            onClick={onClose}
                        />
                    )}
                </div>
            </div>

            {statusBar}

            <div
                className={`px-4 py-4 space-y-4 text-sm text-texts-secondary300 overflow-auto break-words ${contentClassName}`}
            >
                {children}
            </div>
        </div>
    );
};
